import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./afla-modules-list.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./afla-modules-list.component.scss?ngResource";
import { ChangeDetectorRef, Component, } from "@angular/core";
import { forkJoin } from "rxjs";
import { map } from "rxjs/operators";
import { Router } from "@angular/router";
import { DashboardConstants } from "../dashboard.constants";
import { AppControllerService } from "../../../app-controller.service";
import { AppRoutingConstants } from "../../../app-routing.constants";
import { ApplicationsRoutingConstants } from "../../../tabs/applications/applications-routing.constants";
import { UserInformationService } from "../../../shared/services/user/user-information.service";
import SearchUtils from "../../../shared/utils/search-utils";
import { DashboardService } from "../shared/dashboard.service";
import { AutoUnsub } from "src/app/shared/decorators/autounsub.decorator";
import { LocalStorageService } from "src/app/shared/services/storage/local-storage.service";
import { LocalStorageEnum } from "src/app/shared/services/storage/local-storage-constants";
import { OrganisationRoutingConstants } from "../../organisations/organisation-settings-routing.constants";
let AflaModulesListComponent = class AflaModulesListComponent {
    router;
    dashboardService;
    appControllerService;
    changeDetector;
    userInformationService;
    localStorage;
    $visibleModules;
    $systemModules;
    columns;
    searchedModuleName;
    modulesSearchPlaceHolder = DashboardConstants.MODULES_SEARCH_PLACEHOLDER_TEXT;
    searchDebounce = 0;
    overdueCounts;
    fiveDayToGos;
    statusCounts;
    visibleModules;
    getOverdueCounts;
    getFiveDayToGos;
    getStatusCounts;
    moduleIds;
    dataMemo;
    dashboardSubscription;
    constructor(router, dashboardService, appControllerService, changeDetector, userInformationService, localStorage) {
        this.router = router;
        this.dashboardService = dashboardService;
        this.appControllerService = appControllerService;
        this.changeDetector = changeDetector;
        this.userInformationService = userInformationService;
        this.localStorage = localStorage;
    }
    ngOnInit() {
        this.$systemModules = this.userInformationService.$systemModules;
        this.setUpVisibleModules();
        // this.redirectToDefaultLink();
        // this.columns = this.setColumns();
    }
    redirectToDefaultLink() {
        if (this.localStorage.get(LocalStorageEnum.Url)) {
            let url = this.localStorage.get(LocalStorageEnum.Url).toString();
            this.localStorage.set(LocalStorageEnum.Url, null);
            this.localStorage.remove(LocalStorageEnum.Url);
            url = url.replace(/"/g, "");
            url = url.replace("/afla", "");
            if (this.extractOrganizationId(url))
                this.router.navigateByUrl(url);
            if (this.extractModulId(url))
                this.router.navigateByUrl(url);
        }
    }
    extractOrganizationId(url) {
        const urlArray = url.split("/");
        const organisationId = +urlArray[1];
        const organisationRoute = urlArray[2];
        if (organisationRoute === OrganisationRoutingConstants.ORGANISATION_SETTINGS_ROUTE.replace("-", "") && organisationId) {
            this.appControllerService.selectedOrganisationID(organisationId);
            return true;
        }
        return false;
    }
    extractModulId(url) {
        const urlArray = url.split("/");
        const moduleId = +urlArray[1];
        const stepId = urlArray[5];
        if (stepId && urlArray[4] == "step") {
            const stepId = urlArray[5];
            this.appControllerService.updateStepToLoad(stepId);
        }
        if (moduleId) {
            this.appControllerService.setSelectedModule(moduleId);
            return true;
        }
        return false;
    }
    openApplications(module) {
        this.appControllerService.setSelectedModule(module.id);
        this.router.navigate([
            AppRoutingConstants.ROUTE_SEPERATOR +
                this.appControllerService.selectedModuleID +
                AppRoutingConstants.ROUTE_SEPERATOR +
                ApplicationsRoutingConstants.APPLICATIONS_ROUTE,
        ]);
    }
    searchModules($event) {
        this.searchedModuleName = $event;
        this.$systemModules
            .pipe(map((modules) => modules.filter((module) => SearchUtils.searchItemProperty(module, "name", $event))))
            .subscribe((s) => {
            this.visibleModules = s;
            this.handleDashboardData();
            this.changeDetector.markForCheck();
        });
    }
    setUpVisibleModules() {
        this.$systemModules
            .pipe(map((modules) => {
            return modules.sort((a, b) => 0 - (`${a.organisation.name.toLowerCase()}${a.name.toLowerCase()}` > `${b.organisation.name.toLowerCase()}${b.name.toLowerCase()}` ? -1 : 1));
        }))
            .subscribe((modules) => {
            this.visibleModules = modules;
            this.dataMemo = modules;
            this.moduleIds = modules.map((m) => m.id);
            this.dashboardSubscription =
                forkJoin({
                    getOverdueCounts: this.dashboardService.getOverdueApplications(this.moduleIds),
                    getFiveDayToGos: this.dashboardService.getLatestApplications(this.moduleIds),
                    getStatusCounts: this.dashboardService.getMultipleStatusCount(this.moduleIds),
                })
                    .subscribe(({ getOverdueCounts, getFiveDayToGos, getStatusCounts }) => {
                    this.getOverdueCounts = getOverdueCounts;
                    this.getFiveDayToGos = getFiveDayToGos;
                    this.getStatusCounts = getStatusCounts;
                    this.handleDashboardData();
                    this.changeDetector.detectChanges();
                });
            this.changeDetector.detectChanges();
        });
        this.redirectToDefaultLink();
    }
    handleDashboardData() {
        this.overdueCounts = new Map();
        this.fiveDayToGos = new Map();
        this.moduleIds.forEach(el => {
            this.overdueCounts.set(el, "0");
            this.fiveDayToGos.set(el, "0");
        });
        this.getOverdueCounts.forEach((el) => {
            this.overdueCounts.set(el.moduleId, el.applicationCount.toString());
        });
        this.getFiveDayToGos.forEach((el) => {
            this.fiveDayToGos.set(el.moduleId, el.applicationCount.toString());
        });
        this.statusCounts = new Map();
        this.getStatusCounts.forEach((el) => {
            this.statusCounts.set(el.moduleId, el.statuses);
        });
    }
    static ctorParameters = () => [
        { type: Router },
        { type: DashboardService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: UserInformationService },
        { type: LocalStorageService }
    ];
};
AflaModulesListComponent = __decorate([
    Component({
        selector: "app-afla-modules-list",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    }),
    AutoUnsub()
], AflaModulesListComponent);
export { AflaModulesListComponent };
